import api from "../../../utils/axiosInstance"

const BASE = "/payment-methods/"

const normalizeList = response => {
  const data = response.data
  if (Array.isArray(data)) return data
  if (Array.isArray(response.data.results)) return response.data.results
  if (Array.isArray(response.data.data)) return response.data.data
  console.warn("Unexpected format in paymentMethodService.list:", response)
  return []
}

const list = async () => {
  const response = await api.get(BASE)
  return normalizeList(response)
}

const get = async id => {
  const response = await api.get(`${BASE}${id}/`)
  return response.data
}

const create = async payload => {
  const response = await api.post(BASE, payload)
  return response.data
}

const update = async (id, payload) => {
  const response = await api.put(`${BASE}${id}/`, payload)
  return response.data
}

const remove = async id => {
  const response = await api.delete(`${BASE}${id}/`)
  return response.data
}

export default {
  list,
  get,
  create,
  update,
  remove,
}
